const getOEMConfig = () => {
    const {REACT_APP_PROD_URL, REACT_APP_LEGACY_PROD_URL} = process.env
    const envRegex = {
        pr: /^https?:\/\/[^/]+-pr\d+/,
        local: /^https?:\/\/localhost:3000/,
        localAlternate: /^https?:\/\/localhost:3001/,
        dev: /^https?:\/\/[^/]+-dev[^/]+\/?/,
        qa: /^https?:\/\/[^/]+-qa[^/]+\/?/,
        staging: /^https?:\/\/[^/]+-staging[^/]+\/?/
    }
    if (REACT_APP_PROD_URL) envRegex.prod = new RegExp(`^https?://(www\\.)?${REACT_APP_PROD_URL.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&')}/?`)
    if (REACT_APP_LEGACY_PROD_URL) envRegex.legacyProd = new RegExp(`^https?://(www\\.)?${REACT_APP_LEGACY_PROD_URL.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&')}/?`)

    const url = window.location.href

    const findKey = (obj, predicate = o => o) => Object.keys(obj)
        .find(key => predicate(obj[key], key, obj))

    let environment = findKey(envRegex, env => env.test(url)) || 'dev'
    if (environment === 'legacyProd') environment = 'prod'

    return {
        qa: 'https://api.dev.telematicsplatform.io/telematics/comms/mc-telematics-comms-cxsupportal-mioe-oem-ui/',
        local: 'https://api.dev.telematicsplatform.io/telematics/comms/mc-telematics-comms-cxsupportal-mioe-oem-ui/',
        localAlternate: 'https://api.dev.telematicsplatform.io/telematics/comms/mc-telematics-comms-cxsupportal-mioe-oem-ui/',
        staging: 'https://api.staging.telematicsplatform.io/telematics/comms/mc-telematics-comms-cxsupportal-mioe-oem-ui/'
    }[environment] || 'https://api.telematicsplatform.io/telematics/comms/mc-telematics-comms-cxsupportal-mioe-oem-ui/'
}

module.exports = {getOEMConfig}
